import styled from 'styled-components/macro';

import ButtonBase from '@components/common/core/Inputs/Button';

export const DisableButtonBackground = styled.div`
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.background[11]};
  position: absolute;
  width: 100%;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  left: 0;
`;

export const DisableButtonWrapper = styled.div`
  display: flex;
`;

export const DisableIntegrationButton = styled(ButtonBase)`
  margin-left: 20px;
  border: 2px solid ${({ theme }) => theme.colors.danger.default};
  box-shadow: none;

  &:hover {
    border: 2px solid ${({ theme }) => theme.colors.danger.default};
    box-shadow: none;
  }

  & > span {
    color: ${({ theme }) => theme.colors.danger.default};

    &:hover {
      color: ${({ theme }) => theme.colors.danger.default};
    }
  }
`;
